import { Address, PublicClient, WalletClient } from 'viem';

import { getMainTokenContract } from 'modules/api/contracts/getMainTokenContract';
import { memoizePromise } from 'modules/api/methods/memoizePromise';

async function _getStakingPoolFactoryAddress(
  client: WalletClient | PublicClient,
): Promise<Address> {
  const contract = getMainTokenContract(client);

  return await contract.read.poolFactory();
}

export const getStakingPoolFactoryAddress = memoizePromise(
  _getStakingPoolFactoryAddress,
  client => {
    return `${client.chain?.id || 'unknown'}`;
  },
);
